import { faUpload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useRef, useState } from "react";
import { Button, Form } from "react-bootstrap";
import "./MRM_Form.css";
import Success_Toster from "../../../../../../../common/common_modal/success_toster/Success_Toster";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";

import {
  Create,
  GetAll,
} from "../../../../../../../../src/features/admin/quality_management/management_system/Slice";

function MRM_Form({ managementsystemTypeId, handleClose }) {
  const dispatch = useDispatch();

  const [degreePreview, setDegreePreview] = useState(null);
  const degreeInputRef = useRef(null);

  const {
    handleSubmit,
    register,
    formState: { errors },
    setValue,
    reset,
    watch,
    getValues,
  } = useForm();
  const [success, setSuccess] = useState(false);

  // ⏱ auto hide success toaster after 3 sec
  useEffect(() => {
    if (success) {
      const timer = setTimeout(() => {
        setSuccess(false);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [success]);

  const onSubmit = async (data) => {
    try {
      const formData = new FormData();

      formData.append("management_system_type_id", managementsystemTypeId);
      formData.append("name", data.name);
      formData.append("start_date", data.start_date);
      formData.append("end_date", data.end_date);
      formData.append("remark", data.remark);
      formData.append("attach_file", data.attach_file[0]);
      const res = await dispatch(Create(formData));

      if (res.meta.requestStatus === "fulfilled") {
        await dispatch(
          GetAll({
            page: 1,
            per_page: 10,
            management_system_type_id: managementsystemTypeId,
          }),
        );

        reset();
        setDegreePreview(null);

        if (degreeInputRef.current) {
          degreeInputRef.current.value = "";
        }

        setSuccess(true);
        handleClose();
      }
    } catch (error) {
      console.error("Submit error:", error);
    }
  };

  return (
    <section className="Legal_Entity_Form">
      <div className="white_container customer_section">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="row">
            {/* Document Name */}
            <div className="col-md-4">
              <Form.Group className="form_group">
                <Form.Label>Document Name</Form.Label>{" "}
                <Form.Control
                  placeholder="Document Name"
                  {...register("name", {
                    required: "Document Name is required",
                  })}
                />
                {errors.name && (
                  <Form.Text className="text-danger">
                    {errors.name.message}
                  </Form.Text>
                )}
              </Form.Group>
            </div>

            {/* Start Date */}
            <div className="col-md-4">
              <Form.Group className="form_group">
                <Form.Label>Start Date Of Last MRM</Form.Label>
                <Form.Control
                  type="date"
                  {...register("start_date", {
                    required: "Start Date is required",
                    // validate: (value) => {
                    //   const year = value.split("-")[0];

                    //   if (year.length !== 4) {
                    //     return "Year must be exactly 4 digits";
                    //   }

                    //   const selectedDate = new Date(value);
                    //   const today = new Date();
                    //   today.setHours(0, 0, 0, 0);

                    //   if (selectedDate < today) {
                    //     return "Past dates are not allowed";
                    //   }

                    //   return true;
                    // },
                  })}
                  onChange={(e) => {
                    let value = e.target.value;
                    const parts = value.split("-");

                    if (parts[0] && parts[0].length > 4) {
                      parts[0] = parts[0].slice(0, 4);
                      e.target.value = parts.join("-");
                    }
                  }}
                />
                {errors.start_date && (
                  <Form.Text className="text-danger">
                    {errors.start_date.message}
                  </Form.Text>
                )}{" "}
              </Form.Group>
            </div>

            {/* End Date */}
            <div className="col-md-4">
              <Form.Group className="form_group">
                <Form.Label>End Date Of Last MRM</Form.Label>
                <Form.Control
                  type="date"
                  {...register("end_date", {
                    required: "End Date is required",
                    // validate: (value) => {
                    //   const year = value.split("-")[0];

                    //   if (year.length !== 4) {
                    //     return "Year must be exactly 4 digits";
                    //   }

                    //   const selectedDate = new Date(value);
                    //   const today = new Date();
                    //   today.setHours(0, 0, 0, 0);

                    //   if (selectedDate < today) {
                    //     return "Past dates are not allowed";
                    //   }

                    //   return true;
                    // },
                  })}
                  onChange={(e) => {
                    let value = e.target.value;
                    const parts = value.split("-");

                    if (parts[0] && parts[0].length > 4) {
                      parts[0] = parts[0].slice(0, 4);
                      e.target.value = parts.join("-");
                    }
                  }}
                />
                {errors.end_date && (
                  <Form.Text className="text-danger">
                    {errors.end_date.message}
                  </Form.Text>
                )}{" "}
              </Form.Group>
            </div>

            {/* Attached File */}
            <div className="col-md-4">
              <Form.Group className="form_group file_field">
                <Form.Label>Attach File</Form.Label>

                <div className="absolute_fields">
                  <Form.Control
                    type="file"
                    {...register("attach_file", {
                      required:
                        typeof getValues("attach_file") === "string"
                          ? false
                          : "File is required",
                    })}
                    accept="*"
                  />

                  <div className="upload_icon_holder">
                    <FontAwesomeIcon icon={faUpload} className="upload_icon" />
                  </div>
                </div>

                {errors.attach_file && (
                  <small className="text-danger">
                    {errors.attach_file.message}
                  </small>
                )}

                {(() => {
                  const fileValue = watch("attach_file");

                  // URL for preview
                  const fileUrl =
                    typeof fileValue === "string"
                      ? process.env.REACT_APP_IMG_URL + fileValue
                      : fileValue?.length > 0
                      ? URL.createObjectURL(fileValue[0])
                      : null;

                  // Type detection
                  const fileType =
                    typeof fileValue === "string"
                      ? fileValue.toLowerCase()
                      : fileValue?.[0]?.type;

                  if (!fileUrl) return null;

                  return (
                    <div className="preview-container">
                      {/* IMAGE */}
                      {(fileType?.includes("image") ||
                        fileType?.endsWith(".jpg") ||
                        fileType?.endsWith(".jpeg") ||
                        fileType?.endsWith(".png")) && (
                        <img
                          src={fileUrl}
                          alt="Preview"
                          className="image-preview"
                          style={{ maxWidth: "100px" }}
                        />
                      )}

                      {/* PDF */}
                      {(fileType === "application/pdf" ||
                        fileType?.endsWith(".pdf")) && (
                        <iframe
                          src={fileUrl}
                          style={{ maxWidth: "100px" }}
                          title="PDF"
                        />
                      )}

                      {/* WORD */}
                      {(fileType?.includes("word") ||
                        fileType?.endsWith(".doc") ||
                        fileType?.endsWith(".docx")) && (
                        <div>
                          <p>Word preview not supported</p>
                          <a
                            href={fileUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Open / Download Word File
                          </a>

                          <iframe
                            src={`https://docs.google.com/gview?url=${fileUrl}&embedded=true`}
                            style={{ maxWidth: "100px" }}
                            title="Word Preview"
                          />
                        </div>
                      )}

                      {/* EXCEL */}
                      {(fileType?.includes("spreadsheet") ||
                        fileType?.endsWith(".xlsx") ||
                        fileType?.endsWith(".xls")) && (
                        <div>
                          <p>Excel preview not supported</p>
                          <a
                            href={fileUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Open / Download Excel File
                          </a>
                        </div>
                      )}
                    </div>
                  );
                })()}
              </Form.Group>
            </div>

            {/* Remark */}
            <div className="col-md-4">
              <Form.Group className="form_group">
                <Form.Label>Remark</Form.Label>
                <Form.Control
                  placeholder="Remark"
                  {...register("remark", {
                    required: "Remark is required",
                  })}
                />
                {errors.remark && (
                  <Form.Text className="text-danger">
                    {errors.remark.message}
                  </Form.Text>
                )}{" "}
              </Form.Group>
            </div>
          </div>

          {/* Buttons */}
          <div className="permission_btn_holder">
            {success ? (
              <Success_Toster successText="Save Audit Successfully!" />
            ) : (
              <>
                <Button
                  type="button"
                  className="permission_btn No_btn"
                  onClick={handleClose}
                >
                  Reset
                </Button>

                <Button type="submit" className="permission_btn Yes_btn">
                  Save
                </Button>
              </>
            )}
          </div>
        </form>
      </div>
    </section>
  );
}

export default MRM_Form;
